'use client';

import React, { useState } from "react";
import ServiceOverview from "../components/ServiceOverview/ServiceOverview";
import FirstBlockAbout from "@/components/common/FirstBlockAbout";

const ServicesPage: React.FC = () => {
  return (
    <div className="flex my-[35px] w-full flex-col items-center gap-[100px]">
      <FirstBlockAbout
        title="Get Your project done by enjoyable design inc."
        tags={["Development", "Design", "Marketing"]}
        buttonText="Get a Free Consultation"
        buttonLink="/contact"
        highlightWords={["enjoyable", "design", "inc."]}
        media={{
          type: "image",
          src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FFirst%20Block%20Images%2Fpawel-czerwinski-9wAj7tkzdH4-unsplash_1.webp?alt=media&token=15f8961d-179f-4537-ba1f-94c5886c4d4f",
        }}
      />
      <ServiceOverview
        title="Development"
        subtitle="We deliver high-performance custom web development services, professional website development, intuitive mobile app designs, SEO-optimized landing pages, and scalable e-commerce website development using advanced technologies like React and Next.js."
        id="development"
        containers={[
          {
            containerTitle: "Website Maintenance",
            containerSubtitle:
              "Expert custom web development services tailored to your business needs. We build robust, scalable, and secure custom web applications that deliver seamless user experiences.",
            buttonText: "Go To Development Page",
            containerLink: "/services/developing#web-maintenance",
            buttonLink: "/services/developing",
          },
          {
            containerTitle: "Second Container",
            containerSubtitle: "This is the third container subtitle.",
            innerDivs: [
              {
                title: "Website Development",
                link: "/services/developing#development",
                description:
                  "Professional website development services designed to create engaging, user-friendly websites. Our expert website developers ensure performance, responsiveness, and impact.",
              },
              {
                title: "Mobile Apps",
                link: "/services/developing#mobile-apps",
                description:
                  "Leading mobile app development services for iOS and Android. We design intuitive mobile apps with creative UI/UX that enhance user engagement and drive conversions.",
              },
            ],
          },
          {
            containerTitle: "Third Container",
            containerSubtitle: "This is the second container subtitle.",
            innerDivs: [
              {
                title: "Landings",
                link: "/services/developing#landings",
                description:
                  "Transform your business with high-performing landing page development services. We design landing pages that convert visitors into leads and grow your online presence.",
              },
              {
                title: "E-commerce Development",
                link: "/services/developing#e-commerce-development",
                description:
                  "Boost your online store with custom e-commerce website development. From design to functionality, we build e-commerce platforms that drive sales and customer satisfaction.",
              },
            ],
          },
        ]}
      />
      <ServiceOverview
        title="Design"
        subtitle="Comprehensive Expertise in Digital Solutions: Web Design, Full-Stack Development, Mobile Applications, Digital Marketing, Graphic Design, SEO, and Advanced Technologies like React & Next.js"
        id="design"
        containers={[
          {
            containerTitle: "Website Design (UX,UI)",
            containerSubtitle:
              "At Enjoyable Design, we are passionate about creating websites. Our working prototypes are designed with exceptional UX (user experience) and UI (user interface) to ensure customer interaction is flawless and conversion levels are high.",
            buttonText: "Go To Design Page",
            buttonLink: "/services/design",
            containerLink: "/services/design#website-design",
          },
          {
            containerTitle: "Second Container",
            containerSubtitle: "This is the third container subtitle.",
            innerDivs: [
              {
                title: "Logotype Design",
                link: "/services/design#logotype-design",
                description:
                  "Logotype is the face of your brand. That's why we use modern creative designs to encapsulate the essence of your business and transform it into a logotype that reflects your brand's heart and soul.",
              },
              {
                title: "Graphic Design",
                link: "/services/design#graphic-design",
                description:
                  "Creating visually stunning brand books, posters, boxes and package designs, business cards, billboards, and much more. We do visuals that stay in the mind, fully custom and tailored for your business.",
              },
            ],
          },
          {
            containerTitle: "Third Container",
            containerSubtitle: "This is the second container subtitle.",
            innerDivs: [
              {
                title: "Branding",
                link: "/services/design#branding",
                description:
                  "We believe that behind every brand, there are ideas. That's why we not only develop branding strategy that includes logotype, brandbook, and visuals, but also create the philosophy behind it.",
              },
              {
                title: "Presentation",
                link: "/services/design#presentation",
                description:
                  "The right pitch or presentation can make a world of difference in any business field. We take the idea of presentations to a new level with compelling stories all to present your ideas to the audience.",
              },
            ],
          },
        ]}
      />
      <ServiceOverview
        title="Marketing"
        subtitle="Comprehensive Expertise in Digital Solutions: Web Design, Full-Stack Development, Mobile Applications, Digital Marketing, Graphic Design, SEO, and Advanced Technologies like React & Next.js"
        id="marketing"
        containers={[
          {
            containerTitle: "Search Engine Optimization (SEO)",
            containerSubtitle:
              "SEO is about making sure your website speaks the same language as search engines. From keyword research to on-page optimization, technical SEO, and link building, we make sure your site is optimized for both the search engine robots and real people.",
            buttonText: "Go To Marketing Page",
            buttonLink: "/services/marketing",
            containerLink: "/services/marketing#search-engine-optimization",
          },
          {
            containerTitle: "Second Container",
            containerSubtitle: "This is the third container subtitle.",
            innerDivs: [
              {
                title: "Pay-Per-Click (PPC) Advertising",
                link: "/services/marketing#pay-per-click-advertising",
                description:
                  "Let`s face it, every business is unique. So why would we treat yours like it`s just another “standard” ad campaign? We don`t. That means no generic, one-size-fits-all ads.",
              },
              {
                title: "Social Media Marketing (SMM)",
                link: "/services/marketing#social-media-marketing",
                description:
                  "SMM marketing is about building trust through resonating content. And that trust is what eventually turns followers into customers. No matter, it's Instagram, Facebook or Tiktok, your message should be seen. ",
              },
            ],
          },
          {
            containerTitle: "Third Container",
            containerSubtitle: "This is the second container subtitle.",
            innerDivs: [
              {
                title: "Email Marketing",
                link: "/services/marketing#email-marketing",
                description:
                  "We create personalized email campaigns using automation platforms like Mailchimp to ensure your campaigns sell and create engaging customer-seller relationships.",
              },
              {
                title: "Analytics and Reporting",
                link: "/services/marketing#analytics-and-reporting",
                description:
                  "Understanding and analyzing your data is the fastest and safest way to get insights and build a strategy around your brand. We do full data analysis and reporting to create strategies and marketing campaigns.",
              },
            ],
          },
        ]}
      />
    </div>
  );
};

export default ServicesPage;
